module.exports = __webpack_public_path__ + "static/media/125-finland.eccd768b.svg";